import { Injectable } from '@angular/core';
import { Data2Service } from './data2.service';
import { map, tap, Observable } from 'rxjs';

export interface PortfolioData {
    s: number;
    b: number;
    equity: number;
    investmentSymbol: string;
    investment: any;
    post: string;
  }

@Injectable({
  providedIn: 'root'
})

export class PortfolioParserService {



  constructor(private data2Service: Data2Service) { }

    parsePortfolioMix(mixParam: string): Observable<PortfolioData> {
      console.log("parsePortfolioMix called with mixParam:", mixParam);
      let s = 18;
      let b = 8;
      let equity = 50;
      let investmentSymbol = '';
      let post = 'sr_ifa';

      if(mixParam && /^\d+$/.test(mixParam) && parseInt(mixParam, 10) >= 0 && parseInt(mixParam, 10) <= 100){
        // If it's purely numeric, treat as equity with default s2-b2
        console.log("PortfolioParserService detected numeric only mixParam:", mixParam);
        equity = parseInt(mixParam, 10);        
        mixParam = `s18-b8-${equity}`;
      }

      mixParam?.split('-').forEach((part: string) => {

        //console.log("PortfolioParserService parsing part:", part);

        if (part.startsWith('s')) {
          s = parseInt(part.replace('s', ''), 10);
        } else if (part.startsWith('b')) {
          b = parseInt(part.replace('b', ''), 10);
        } else {
          const eq = parseInt(part, 10);
          if (eq != null && eq >= 0 && eq <= 100) {
            equity = eq;
           // console.log("PortfolioParserService Parsed equity:", equity);
          }
        }
      });

      // Determine investment symbol and post based on s, b, equity
      if (s === 1 && b === 1) { investmentSymbol = `port${equity}_ifa`; post = '_ifa'; }
      else if (s === 1 && b === 2) { investmentSymbol = `port${equity}t_ifa`; post = 't_ifa'; }
      else if (s === 2 && b === 2) { investmentSymbol = `port${equity}cp_ifa`; post = 'cp_ifa'; }
      else if (s === 11 && b === 1) { investmentSymbol = `port${equity}lt_ifa`; post = 'lt_ifa'; }
      else if (s === 12 && b === 1) { investmentSymbol = `port${equity}mt_ifa`; post = 'mt_ifa'; }
      else if (s === 18 && b === 8) { investmentSymbol = `port${equity}sr_ifa`; post = 'sr_ifa'; }
      else { investmentSymbol = 'Portfolio Unavailable'; }

      if(investmentSymbol !== 'Portfolio Unavailable'){

        let data =   this.data2Service.investment$(`?$filter=symbol eq '${investmentSymbol}'`).pipe(
          map((v) => ({
            s,
            b,
            equity,
            investmentSymbol,
            investment: v.length > 0 ? v[0] : null,
            post
          })),
          tap((portfolioData) => this.setInvestmentName(portfolioData))
        );
         return data;

      }
      else{
        let data = new Observable<PortfolioData>((observer) => {
          observer.next({
            s: s,
            b: b,
            equity: equity,
            investmentSymbol : investmentSymbol,
            investment: {displayName: "Portfolio Unavailable", description: "The specified portfolio configuration is not available."},
            post: post
          });
          observer.complete();
        });
        return data;
     
    }
  }

     setInvestmentName(data:PortfolioData){
      
      if(data.investment){
        const name = data.investment.ifa_name ? data.investment.ifa_name : data.investment.name;  
          const regex = /(S\d+B\d+)$/;  
            
          if (regex.test(name) || name.indexOf("IFC") > -1) {  
            // If it already ends with S#B#, wrap it in a span  
            data.investment.displayName = name.replace(  
              regex,  
              "<span style=''>$1</span>"  
            );  
          } else {  
            // If it doesn't match, append S1B1 and wrap that. It is not the default, just S1B1 is the only one that is not suffixed with a code.
            data.investment.displayName = `${name} <span style=''>S1B1</span>`;  
          }  
          //console.log("setInvestmentName", data.investment.displayName, name);
        }
      }
}
